import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import PropTypes from 'prop-types';
import { ThemeImages } from '../../theme';
import theme from '../../app.theme';

class TemporaryDrawer extends Component {


  onDashboardSelected() {
    this.props.onNavigate(`${this.props.basePath}Dashboard`);
  }

  renderExamItem() {
    if (this.props.config.examsEnabled && this.props.config.examsEnabled === 'false') {
      return null;
    }

    return (
      <ListItem button onClick={this.props.onExamsSelected}>
        <ListItemText primary="Prüfungen" />
      </ListItem>
    );
  }

  renderBulletinBoardItem = () => {
    if (this.props.config.bulletinBoardActive && this.props.config.bulletinBoardActive === 'false') {
      return null;
    }

    return (
      <ListItem button onClick={this.props.onBulletinBoardSelected}>
        <ListItemText primary="Meine Inhalte" />
      </ListItem>
    );
  }

  renderSocialWallBoardItem = () => {
    if (this.props.config.socialWallActive && this.props.config.socialWallActive === 'false') {
      return null;
    }

    return (
      <ListItem button onClick={this.props.onSocialWallSelected}>
        <ListItemText primary="Social Wall" />
      </ListItem>
    );
  }

  renderDrawerContent() {
    const { classes } = this.props;
    return (
      <div
        className={classes.list}
        role="presentation"
        onClick={this.props.closeDrawer}
        onKeyDown={this.props.closeDrawer}
      >
        <div onClick={() => this.props.onHomeSelected()} style={{ padding: '10px 0', textAlign: 'center' }}>
          <img src={ThemeImages.iconPath} alt="Logo" style={{ height: 80 }} />
        </div>

        <Divider />

        <ListItem button onClick={this.props.onCoursesSelected}>
          <ListItemText primary="Inhalte" />
        </ListItem>
        <ListItem button onClick={this.props.onTestsSelected}>
          <ListItemText primary="Test" />
        </ListItem>
        <ListItem button onClick={this.props.onChecklistsSelected}>
          <ListItemText primary="Checklisten" />
        </ListItem>
        {this.renderExamItem()}
        <ListItem button onClick={this.props.onResultsSelected}>
          <ListItemText primary="Ergebnisse" />
        </ListItem>
        {this.renderBulletinBoardItem()}
        {this.renderSocialWallBoardItem()}

        <Divider />

        <ListItem button onClick={() => this.props.onLogout()}>
          <ListItemText primary="Logout" />
        </ListItem>
      </div>
    );
  }


  render() {
    return (
      <div>
        <Drawer open={this.props.open} onClose={this.props.closeDrawer}>
          {this.renderDrawerContent()}
          {/* {sideList('left')} */}
        </Drawer>

      </div>
    );
  }
}

const styles = theme => ({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

TemporaryDrawer.propTypes = {
  config: PropTypes.object,
};

TemporaryDrawer.defaultProps = {
  config: {},
};


export default withStyles(styles)(TemporaryDrawer);



// WEBPACK FOOTER //
// ./src/app/components/drawer/drawer.js